<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="600"
      persistent
    >
      <v-btn
        color="black white--text"
        v-if="canBeArchiveFolder()"
        slot="activator"
      >
        <v-icon small left>mdi-archive</v-icon>
        Arquivar
      </v-btn>
      <v-card>
        <v-toolbar color="grey lighten-3" flat>
          <v-icon class="mr-3">mdi-archive</v-icon>
          <span class="headline grey--text text--darken-2">Arquivar Processo</span>
          <v-spacer/>
        </v-toolbar>
        <v-container grid-list-md>
          <v-card-text class="my-4 text-xs-center">
            <v-layout column align-center>
              <img class="mb-4"
                   src="/static/images/folder/grupo.svg"
                   alt="Arquivar"
              />
              <span class="subheading font-weight-regular grey--text text--darken-1">Após arquivado, o processo ficará inativo.</span>
              <span class="subheading font-weight-bold">Todos os processos apensados também serão arquivados.</span>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn flat :disabled="archiveLoading" @click="cancel()">CANCELAR</v-btn>
              <v-dialog
                v-model="signatureSignGoPasswordDialog"
                width="400"
                persistent
              >
                <template v-slot:activator="{ on }">
                  <v-btn color="black white--text"
                         @click="signatureSignGoPasswordDialog = true"
                         :loading="archiveLoading">Confirmar
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title
                    class="headline primary white--text"
                    primary-title
                  >
                    Assinar documento
                  </v-card-title>

                  <v-card-text>
                    <span>
                        Por favor, insira sua senha para confirmar a assinatura do documento
                    </span>

                    <v-text-field
                      label="Senha"
                      v-model="password"
                      type="password"
                      persistent-hint
                      hint="Sua senha de acesso"
                    />
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      flat
                      @click="cancel()"
                      :disabled="archiveLoading">
                      Cancelar
                    </v-btn>
                    <v-btn
                      color="primary"
                      @click="archiveFolder()"
                      :loading="archiveLoading"
                      :disabled="archiveLoading">
                      Assinar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

            </v-layout>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import folderService from '@/services/FoldersService';
import { includes } from 'lodash';

export default {
  name: 'ArchiveFolderDialog',
  data() {
    return {
      dialog: false,
      signatureSignGoPasswordDialog: false,
      archiveLoading: false,
      password: '',
    };
  },
  methods: {
    cancel() {
      this.dialog = false;
      this.signatureSignGoPasswordDialog = false;
    },
    folderArchived() {
      return this.$store.getters.folderStatusArchived.name === this.folder.folder_status.name;
    },
    canBeArchiveFolder() {
      // 1 - Irineu // 92 - Polly // 164 - Gustavo // 505 - Leonardo // 511 - joelma// 546 - samya
      return !this.folderArchived() &&
        includes([1, 92, 164, 505, 511, 546], this.$store.getters.user.id);
    },
    archiveFolder() {
      if (this.archiveLoading) return;
      this.archiveLoading = true;
      this.$getLocation()
        .then((coords) => {
          folderService
            .archiveFolder(this.folder.id, `${coords.lat}, ${coords.lng}`, this.password)
            .then(() => {
              this.$router.push('/pastas/entrada');
              this.$store.dispatch('toggleSnackbar', {
                show: true,
                timeout: 6000,
                color: 'success',
                message: 'O processo foi arquivado com sucesso.',
                messageIcon: 'mdi-check',
              });
            })
            .catch((err) => {
              this.$store.dispatch('toggleSnackbar', {
                show: true,
                color: 'error',
                message: err.response.data,
                button: { show: true, text: 'Fechar', message: '' },
                timeout: 6000,
                messageIcon: 'mdi-alert-outline',
              });
            })
            .finally(() => {
              this.archiveLoading = false;
            });
        })
        .catch(() => {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'error',
            message: 'Você deve autorizar a obtenção da sua localização para prosseguir com essa ação.',
            button: { show: true, text: 'Fechar', message: '' },
            timeout: 6000,
            messageIcon: 'mdi-alert-outline',
          });
          this.dialog = false;
          this.loading = false;
        });
    },
  },
  computed: {
    folder() {
      return this.$store.getters.activeFolder;
    },
    user() {
      return this.$store.getters.user;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/folder/show/toolbar/action/ArchiveFolderDialog.vue